export default __webpack_public_path__ + "static/media/ppt.4c5ef15c.svg";